var _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaintenanceUniversal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 34.15072,17.062505 c 1.89522,2.307889 2.980386,3.683451 2.980386,5.227138 a 2.980386,2.8275457 0 1 1 -5.960772,0 c 0,-1.543687 1.085166,-2.919249 2.980386,-5.227138 z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 6.2113722,17.243695 c 1.89522,2.307889 2.980386,3.683451 2.980386,5.227138 a 2.9803857,2.8275454 0 1 1 -5.9607712,0 c 0,-1.543687 1.0851661,-2.919249 2.9803852,-5.227138 z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 5.7738541,31.286686 H 34.691238 l 3.622315,7.345189 H 2.1515392 Z m 3.0109537,0.520678 c 1.2074383,-0.202379 3.4389062,-0.148808 4.6463452,0.05357 l -2.155048,6.315435 c -1.4519832,0.202379 -3.8210076,0.238093 -5.2729905,0.04167 z m 8.7424652,-0.06235 c 1.207437,-0.20238 3.958563,-0.17857 5.166001,0.02381 l 0.733635,6.398767 c -1.451985,0.20238 -5.257707,0.196428 -6.694406,-0.0059 z m 14.133483,0.0764 c -1.207439,-0.20238 -3.438907,-0.148809 -4.646346,0.05357 l 2.155049,6.315435 c 1.451983,0.202379 3.821007,0.238093 5.27299,0.04167 z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.2338633,0,0,1.2388272,0.84744894,-4.5901835)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.35,
    y: 25.15,
    width: 2.75,
    height: 1.3,
    rx: 0.30000001
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.049999,
    y: 25.15,
    width: 2.75,
    height: 1.3,
    rx: 0.30000001
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.55,11.85 0.8,12.7 q 0,0.65 0.65,0.65 h 10 q 0.65,0 0.65,-0.65 l 0.8,-12.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.6499996,
    y: 9.75,
    width: 14.7,
    height: 2,
    rx: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.9,9.75 2.55,-3.6 h 9.1 l 2.55,3.6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.75,
    y1: 8.75,
    x2: 13.65,
    y2: 6.1500001
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.25,
    y1: 8.75,
    x2: 18.35,
    y2: 6.1500001
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceUniversal);
export default __webpack_public_path__ + "static/media/maintenance_universal.cfd16d22b9c110460cf10c134ac4d21b.svg";
export { ForwardRef as ReactComponent };